import abstractService from '../abstractService';

const getMerchantCategoriesUrl = (merchantId, quantity, publish) =>
  `merchants/categories?merchantId=${merchantId}&quantity=${quantity}&publish=${publish.toString()}`;

export const getMerchantCategoriesService = (merchantId, quantity, publish) => {
  return abstractService.getRequest(getMerchantCategoriesUrl(merchantId, quantity, publish));
};
